import Backbone from 'backbone'
import $ from 'jquery'
import _ from 'lodash'
import template from './record-list-widget-editor.hbs'
import getEditorTitle from './get-editor-title'
import formHelper from 'scoreboard/components/form-helper'
import DatasetsFilterBadges from 'scoreboard/datasets/filters/datasets-filter-badges'
import recordListColumn from './record-list-column.hbs'
import FormView from 'scoreboard/components/form-view'
import renderFieldDropdown from 'scoreboard/datasets/render-field-dropdown'
import i18n from 'scoreboard/components/i18n'
import CovertButtonTooltips from 'scoreboard/components/covert-button-tooltips'
import DraggableList from 'draggable-list'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import selects from 'scoreboard/components/selects'
import getRecordListFieldIds from './get-record-list-field-ids'
import enums from 'scoreboard/components/enums'
import LabeledToggle from 'scoreboard/components/labeled-toggle'
import FormWidgetType from 'scoreboard/forms/model/form-widget-type'
const { RECORD_LIST } = FormWidgetType
import FormActionType from 'scoreboard/forms/model/form-action-type'
const { GO_TO_PAGE } = FormActionType
import FormActions from '../edit/form-actions'
import widgetMetadata from './widget-metadata'
import {getDialogDatasetOrDataset} from '../edit/pages-edit'

const RecordListWidgetEditor = Backbone.View.extend({

	tagName: 'form',

	className: 'form-widget-editor record-list-widget-editor',

	/** @type {Form} */
	model: null,

	events: {
		'click .add-column': 'onClickAddColumn',
		'click .add-filter': 'onClickAddFilter',
		'click .delete-column': 'onClickDeleteColumn',
		'change [name=fieldId]': 'onChangeFieldId'
	},

	/**
	 * Dialog for editing a Record List form widget
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Form} options.model
	 *
	 * @param {FormWidget} options.widget the data for the widget
	 */
	initialize: function(options = {}) {
		this.options = options
		this.formView = new FormView({
			el: this.el,
			submit: this.submit.bind(this)
		})
		this.formView.test = this.test.bind(this)
		this.markedFields = []
		this.dataset = getDialogDatasetOrDataset(this.model)

		this.fieldIdsInUse = _.map(_.get(this.options, 'widget.columns') , 'fieldId') || []
		this.datasetForFieldDropdowns = _.cloneDeep(this.dataset)
	},

	render: function() {
		this.$el.html(template(this.context()))
		formHelper.writeToDom(this.options.widget, this.el)
		this.renderColumns()
		this.renderFilterBadges()
		this.renderFormActions()
		this.renderButtonLabelField()
		this.formView.start()
		this.renderDraggableColumns()
		this.renderStateToggle()
		this.covertButtonTooltips = new CovertButtonTooltips({ el: this.el })

		return this
	},

	renderColumns: function() {
		// #35008 update the cloned dataset we will be passing into
		// renderFieldDropdown, so the fields will be grouped into used/unused
		this.updateDatasetForFieldDropdowns()
		let columns = _.get(this.options, 'widget.columns')
		_.each(columns, column => {
			this.renderColumn(column)
		})
	},

	/**
	 * @param {FormWidgetColumn} column
	 */
	renderColumn: function(column) {
		let columnToRender = _.clone(column)
		// with #35221 the value for the 'editable' checkbox value is based on
		// previous user selection, not on editability of the field itself
		this.$('.columns').append(recordListColumn(columnToRender))
		let columnEl = this.$('.columns .column').last()
		formHelper.writeToDom(columnToRender, columnEl)
		this.markedFields.push(this.renderFieldDropdown(column))

		// if the field is the manually added field, hide the editable checkbox
		maybeHideEditableCheckbox(columnEl, column, this.dataset)
	},

	renderStateToggle: function() {
		// circular dependency
		let states = widgetMetadata.states[RECORD_LIST]
		this.stateToggle = new LabeledToggle({
			name: 'state',
			value: _.get(this.options.widget, 'state'),
			options: _.filter(enums.toOptionData('widgetState'), item => {
				if (_.includes(states, item.id)) {
					return _.extend(item, { value: item.id })
				}
			})
		})

		this.$('.widget-state .labeled-toggle-container').append(this.stateToggle.el)
		this.stateToggle.render()
		this.stateToggle.on('change', () => {
			this.formView.change()
		})
	},

	/**
	 * Renders the dropdown options for a field select.
	 * We are using a clone of the dataset (this.datasetForFieldDropdowns)
	 * that has a 'group' attribute added to the fields, so the options will be
	 * grouped by used/unused
	 */
	renderFieldDropdown: function(column, columnEl) {
		columnEl = columnEl || this.$('.columns [name=fieldId]').last()
		return renderFieldDropdown({
			el: columnEl,
			dataset: this.datasetForFieldDropdowns,
			required: true,
			allowedVisibleLinkedFieldIds: [],
			selectedId: _.get(column, 'fieldId')
		})
	},

	/**
	 * Updates the 'group' attribute of the  fields in the cloned dataset
	 * we are using to render the field dropdowns(this.datasetForFieldDropdowns),
	 * to reflect the current state of the fields that are used/unused by this
	 * record list widget
	 */
	updateDatasetForFieldDropdowns: function() {
		let fields = this.datasetForFieldDropdowns.get('fields')
		let unusedLabel = i18n.get('admin.import.unused')
		let usedLabel = i18n.get('admin.licenseUsage.used')
		_.each(fields, field => {
			field.group = _.includes(this.fieldIdsInUse, field.id) ? usedLabel : unusedLabel
			// 'type' is the default groupSortAttribute
			field.type = this.fieldIdsInUse[field.id] ? 'used' : 'unused'
		})
	},

	renderFilterBadges: function() {
		this.filterBadges = new DatasetsFilterBadges({
			model: this.dataset,
			filters: _.get(this.options, 'widget.filters'),
			treeItemsById: this.model.treeItemsById
		})
		this.$('.filter-badges-container').append(this.filterBadges.el)
		this.filterBadges.render()
		this.filterBadges.on('add-filter edit-filter delete-filter',
			this.formView.change.bind(this.formView))
	},

	renderFormActions: function() {
		this.actions = new FormActions({
			model: this.model,
			statements: this.options.widget.statements,
			title: i18n.get('forms.actions.title'),
			formView: this.formView,
			emptyMessage: i18n.get('forms.actions.emptyValueChange'),
			allowedActionTypes: [GO_TO_PAGE]
		})
		this.$('.actions-container').append(this.actions.el)
		this.actions.render()
	},

	renderButtonLabelField: function() {
		this.buttonLabelField = new MarkedField({
			el: this.$('[name=buttonLabel]'),
			validator: value => {
				// if there are any actions defined, the button label is required
				if (!_.isEmpty(this.$('.form-action-editor'))) {
					return requiredValidator(value)
				}
			}
		}).render()
	},

	context: function() {
		return {
			title: getEditorTitle(this.options.widget),
			bannerMsg: i18n.get(
				'forms.actions.valueChangeActionsBanner.recordListWidget',
				i18n.get('forms.actions.actionsBannerPart2'))
		}
	},

	onClickAddColumn: function() {
		this.renderColumn()
		this.renderDraggableColumns()
		this.formView.change()
		selects.toggleFocus(this.$('.columns .column:last [name=fieldId]'),
			true)
	},

	onClickAddFilter: function() {
		this.filterBadges.addFilter()
	},

	onClickDeleteColumn: function(e) {
		let columnEl = this.getColumnEl(e)
		columnEl.find('.marked-field').data('view').remove()
		columnEl.remove()
		this.formView.change()
		this.updateFieldDropdowns()
	},

	onChangeFieldId: function(e) {
		// update the other field dropdowns (used/unused grouping)
		this.updateFieldDropdowns()
		// clear out any other selects that have the same value as the newly
		// selected fieldId (prevent selecting duplicate fields)
		if (!_.isEmpty(e.target.value)) {
			_.each(this.$('.column'), col => {
				const sel = this.$(col).find('[name=fieldId]')[0]
				if (sel !== e.target) {
					if (this.$(sel).val() === e.target.value) {
						this.$(sel).val('')
						selects.val(sel, '')

						// we're clearing the value so add back the editable
						// checkbox if it was removed
						this.$(col).find('.editable.label').removeClass(
							'is-not-displayed')
					}
				}
			})
		}
	},

	/**
	 * Updates all of the field selects, so that the fields are grouped by
	 * unused/used
	 */
	updateFieldDropdowns: function() {
		this.updateFieldIdsInUse()
		// update the copy of the dataset (this.datasetFor, so we can have updated grouping of
		// used and unused
		this.updateDatasetForFieldDropdowns()
		_.each (this.$('.column'), columnEl => {
			let column = formHelper.readFromDom(columnEl)
			column.fieldId = _.isEmpty(column.fieldId) ? null : parseInt(column.fieldId)
			column.id = this.$(columnEl).data('id')
			this.renderFieldDropdown(column, this.$(columnEl).find('select[name=fieldId]'))

			// if the field is the manually added field, hide the editable checkbox
			maybeHideEditableCheckbox(this.$(columnEl), column, this.dataset)
		})
	},

	updateFieldIdsInUse: function() {
		let fieldIds = []
		_.each(this.getColumnData(), column => {
			if (!_.isEmpty(column.fieldId)) {
				fieldIds.push(parseInt(column.fieldId))
			}
		})
		this.fieldIdsInUse = fieldIds
	},

	getColumnEl: function(e) {
		return this.$(e.target).closest('.column')
	},

	getColumnData: function() {
		return _.map(this.$('.column'), columnEl => {
			let column = formHelper.readFromDom(columnEl)
			column.id = this.$(columnEl).data('id')
			return column
		})
	},

	renderDraggableColumns: function() {
		let list = this.$('ul.columns')
		if (list.find('.column').length > 1) {
			this.draggableColumns = new DraggableList(list[0])
			this.draggableColumns.on('move', this.formView.change.bind(this.formView))
		}
	},

	test: function() {
		var msg = FormView.prototype.test.apply(this.formView, arguments)
		if (msg) {
			return msg
		}

		let columns = this.getColumnData()
		if (_.isEmpty(columns)) {
			return i18n.get('forms.widgets.widget.record-list.columnsRequired')
		}

		// #35008 check to see if the user has selected the same field id twice
		if (columns.length > _.uniqBy(columns,'fieldId').length) {
			return i18n.get('forms.widgets.widget.record-list.columnDuplicated')
		}
	},

	submit: function() {
		let data = formHelper.readFromDom(this.el)
		data = _.pick(data, 'label', 'description', 'buttonLabel')
		data.type = RECORD_LIST
		data.statements = this.actions.getData()
		data.columns = this.getColumnData()
		data.filters = this.filterBadges.filters

		let recordFieldIds = getRecordListFieldIds(data.columns, this.dataset)
		let datasetId = this.model.get('datasetId')
		let request = {
			records: true,
			id: datasetId,
			recordFieldIds,
			filters: data.filters
		}
		return $.post({
			url: `api/datasets/${datasetId}/query`,
			data: JSON.stringify(request),
			success: recordListResponse => {
				data.recordListResponse = recordListResponse
				let state = formHelper.readFromDom(this.el)?.state
				this.trigger('done', {state, ...data})
			}
		})
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.filterBadges, this.actions,
			this.draggableColumns, this.covertButtonTooltips,
			this.buttonLabelField, this.stateToggle], 'remove')
		_.invokeMap(this.markedFields, 'remove')
	}

})

/**
 * hides the editable checkbox if the column's field is the manually added field
 */
const maybeHideEditableCheckbox = (columnEl, column, dataset) => {
	const isManuallyAddedField = !_.isNil(column?.fieldId) &&
		dataset.getManuallyAddedFieldId() == column?.fieldId
	columnEl.find('.label.editable').toggleClass('is-not-displayed',
		isManuallyAddedField)
}

_.extend(RecordListWidgetEditor, { maybeHideEditableCheckbox })
export default RecordListWidgetEditor
export { maybeHideEditableCheckbox }

RecordListWidgetEditor.__filename__ = 'forms/widgets/record-list-widget-editor.js'
